import { Injectable, Output, EventEmitter } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the AuthStore provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BasicState {

  /**
   * 親情報のアップデート
   */
  @Output() onChangeFamilyDetail = new EventEmitter<Object>();
  triggerFamilyDetailRefresh(data){
    this.onChangeFamilyDetail.emit(data);
  }

  /**
   * 子供情報のアップデート
   */
  @Output() onChangeChildDetail = new EventEmitter<Object>();
  triggerChildDetailRefresh(data){
    this.onChangeChildDetail.emit(data);
  }
  /**
   * 送迎情報のアップデート
   */
   @Output() onChangePickupDetail = new EventEmitter<Object>();
   triggerPickupDetailRefresh(data){
     this.onChangePickupDetail.emit(data);
   }
}



// WEBPACK FOOTER //
// ./src/states/basic-state.ts